import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending the summColumn filter
        );

        return {
            view: 'treetable', // Defining the view as a tree table
            id: 'treetable', // Unique identifier for the tree table
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            columns: [
                // Column definitions for the tree table
                {
                    id: 'TypeName',
                    header: 'TypeName',
                    width: 350,
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouped row display
                        return obj.NameAffiliate; // Display affiliate name
                    },
                },
                {
                    id: 'ActionTittle',
                    header: '',
                    width: 70,
                    height: 25,
                    tooltip: 'Acción', // Tooltip for action column
                    template: function (obj) {
                        // Conditional rendering of action buttons based on state and level
                        if ((obj.State == 'A' || obj.State == null) && obj.$level == 5) {
                            if (devConfig.getPermAction('comissionsReportBetShopApprove', 'Approve')) {
                                return "<span placeholder='Aprobar' class='webix_icon wxi-close approve prm-comissionsReportBetShopApprove'></span><span class='webix_icon icon-history torefuse prm-comissionsReportBetShopApprove'></span>";
                            } else {
                                return '';
                            }
                        } else {
                            if ((obj.State == 'P' || obj.State == null) && obj.$level == 5) {
                                if (devConfig.getPermAction('comissionsReportBetShopPay', 'Pay')) {
                                    return "<span placeholder='Pagar' class='webix_icon wxi-close pay prm-comissionsReportBetShopPay'></span>";
                                } else {
                                    return '';
                                }
                            } else {
                                return '';
                            }
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // ID column
                {
                    id: 'ClientId',
                    header: _('ID Afiliador'), // Localized header for affiliate ID
                    width: 95,
                    sort: 'int',
                },
                {
                    id: 'NameAffiliate',
                    header: _('Nombre Afiliador'), // Localized header for affiliate name
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'ClientRef',
                    header: _('Usuario REF'), // Localized header for REF user
                    width: 95,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocal',
                    header: _('Fecha de creación'), // Localized header for creation date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'CurrencyId',
                    header: _('Moneda'), // Localized header for currency
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Bets',
                    header: _('Apuestas'), // Localized header for bets
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    editor: 'text', // Editable field
                },
                {
                    id: 'Winnings',
                    header: _('Premios'), // Localized header for winnings
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    editor: 'text', // Editable field
                },
                {
                    id: 'Bonus',
                    header: _('Bonos'), // Localized header for bonuses
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    editor: 'text', // Editable field
                },
                {
                    id: 'AmountBase',
                    header: _('Valor Base'), // Localized header for base value
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    editor: 'text', // Editable field
                },
                {
                    id: 'Amount',
                    header: _('Comision'), // Localized header for commission
                    width: 100,
                    sort: 'int',
                    editor: 'text', // Editable field
                    template: function (obj) {
                        var format = webix.Number.numToStr({
                            groupDelimiter: ',',
                            groupSize: 3,
                            decimalDelimiter: '.',
                            decimalSize: 2,
                        });
                        if (parseInt(obj.Amount) < 0 && obj.$level == 2) {
                            return format('0'); // Return zero if amount is negative at level 2
                        } else {
                            return format(obj.Amount); // Format and return the amount
                        }
                    },
                },
                {
                    id: 'AmountPaid',
                    header: _('Valor Pagado'), // Localized header for paid value
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    editor: 'text', // Editable field
                },
                {
                    id: 'State',
                    header: _('Estado'), // Localized header for state
                    options: [
                        { id: '', value: _('None') }, // Option for no state
                        { id: 'A', value: _('Activo') }, // Active state
                        { id: 'I', value: _('Pagada') }, // Paid state
                        { id: 'P', value: _('Pendiente') }, // Pending state
                        { id: 'R', value: _('Rechazada') }, // Rejected state
                    ],
                },
                {
                    id: 'ModifiedLocal',
                    header: _('Modificado'), // Localized header for modified date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
            ],
            onClick: {
                pay: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix
                        .modalbox({
                            title: _('Pregunta '), // Modal title
                            buttons: [
                                _('Efectivo'), // Cash option
                                _('Saldo Recarga'), // Recharge balance option
                                _('Saldo Juego'), // Game balance option
                                _('Saldo Afiliados'), // Affiliate balance option
                                _('Cancelar'), // Cancel option
                            ],
                            text: _('Seleccione el tipo de saldo '), // Modal text
                            width: 500,
                        })
                        .then(function (result) {
                            switch (result) {
                                case '0':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea pagar comisión en efectivo?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for paying commissions
                                                        '{ "Id":"' + item.Id + '", "Type":"0"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parse response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decode base64 data
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slice the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Create byte array
                                                                            byteArrays.push(byteArray); // Push to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType,
                                                                        }); // Create blob from byte arrays
                                                                        return blob; // Return blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Convert to blob
                                                                    var file = window.URL.createObjectURL(blob); // Create object URL for blob
                                                                    console.log(blob); // Log blob for debugging
                                                                    document.querySelector('iframe').src = file; // Set iframe source to blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500',
                                                                    ); // Open print window
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '1':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo recargas?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for paying commissions
                                                        '{ "Id":"' + item.Id + '", "Type":"1"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parse response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decode base64 data
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slice the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Create byte array
                                                                            byteArrays.push(byteArray); // Push to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType,
                                                                        }); // Create blob from byte arrays
                                                                        return blob; // Return blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Convert to blob
                                                                    var file = window.URL.createObjectURL(blob); // Create object URL for blob
                                                                    console.log(blob); // Log blob for debugging
                                                                    document.querySelector('iframe').src = file; // Set iframe source to blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500',
                                                                    ); // Open print window
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '2':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo juego?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for paying commissions
                                                        '{ "Id":"' + item.Id + '", "Type":"2"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parse response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decode base64 data
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slice the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Create byte array
                                                                            byteArrays.push(byteArray); // Push to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType,
                                                                        }); // Create blob from byte arrays
                                                                        return blob; // Return blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Convert to blob
                                                                    var file = window.URL.createObjectURL(blob); // Create object URL for blob
                                                                    console.log(blob); // Log blob for debugging
                                                                    document.querySelector('iframe').src = file; // Set iframe source to blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500',
                                                                    ); // Open print window
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '3':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo afiliados?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for paying commissions
                                                        '{ "Id":"' + item.Id + '", "Type":"3"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parse response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decode base64 data
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slice the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Create byte array
                                                                            byteArrays.push(byteArray); // Push to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType,
                                                                        }); // Create blob from byte arrays
                                                                        return blob; // Return blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Convert to blob
                                                                    var file = window.URL.createObjectURL(blob); // Create object URL for blob
                                                                    console.log(blob); // Log blob for debugging
                                                                    document.querySelector('iframe').src = file; // Set iframe source to blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500',
                                                                    ); // Open print window
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '4':
                                    break; // No action for case 4
                            }
                        });
                },
                approve: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Comisión'), // Confirmation text
                        ok: _('Aprobar Comisión'), // Confirm button
                        cancel: _('Salir'), // Cancel button
                        callback: function (action) {
                            if (action === true) {
                                var item = vthis.getItem(id); // Get the item by ID
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Set content type for AJAX request
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Commisions/ApproveComission', // API endpoint for approving commissions
                                        '{ "Id":' + item.Id + '}', // Request body
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error! ')); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                data = JSON.parse(text); // Parse response
                                                if (!data.HasError) {
                                                    item.State = 'P'; // Update item state to approved
                                                    webix.message(_('Comision Aprobado')); // Success message
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            on: {
                onBeforeLoad: function () {
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay after data load
                },
            },
            ready: function () {
                if (!this.count()) {
                    webix.extend(this, webix.OverlayBox); // Extend with overlay box functionality
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    ); // Show no data overlay
                }
            },
            tooltip: true, // Enable tooltips
            footer: false, // Disable footer
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
            pager: 'pagerA', // Set pager ID
        };
    }

    /**
     * Initializes the grid and sets up event handlers.
     * @param {Object} grid - The grid instance to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Financial/GetMyComissionsResume'; // API endpoint for fetching commissions
        var filter = ''; // Filter string for API requests

        // Event handler for after loading data into the grid
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                // Grouping data by NameAffiliate
                by: 'NameAffiliate',
                map: {
                    NameAffiliate: ['NameAffiliate'],
                    ClientId: ['ClientId'],
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'],
                    Amount: ['Amount', 'sum'],
                    Bets: ['Bets', 'sum'],
                    Winnings: ['Winnings', 'sum'],
                    Bonus: ['Bonus', 'sum'],
                    TypeName: ['TypeName'],
                    TypeG: ['TypeG'],
                    CurrencyId: ['CurrencyId'],
                },
            });
            $$('treetable').data.group({
                // Grouping data by TypeName
                by: 'TypeName',
                map: {
                    TypeName: ['TypeName'],
                    TypeG: ['TypeG'],
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'],
                    Amount: ['Amount', 'sum'],
                    Bets: ['Bets', 'sum'],
                    Winnings: ['Winnings', 'sum'],
                    Bonus: ['Bonus', 'sum'],
                    CurrencyId: ['CurrencyId'],
                },
            });
            $$('treetable').data.group({
                // Grouping data by TypeG
                by: 'TypeG',
                map: {
                    TypeG: ['TypeG'],
                    CurrencyId: ['CurrencyId'],
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'],
                    Amount: ['Amount', 'sum'],
                },
            });
            $$('treetable').data.group({
                // Grouping data by CurrencyId
                by: 'CurrencyId',
                map: {
                    CurrencyId: ['CurrencyId'],
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'],
                    Amount: ['Amount', 'sum'],
                },
            });
        });

        // Event handler for filtering data based on user input
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('deposit:id', [item.Id]); // Trigger event with item ID
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
